import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
    },
    input: {
        display: 'none',
    },
}));

export default function PingPongComponent(props) {
    const classes = useStyles();
    const { label, clickHandler } = props;
    return (
        <div>
            <Button variant="contained" className={classes.button} onClick={() => { if (!!clickHandler) clickHandler() }}>
                {label}
            </Button>
        </div>)
}